import { trackClick } from "@/lib/analytics";

// Mide en GA4 los clics en teléfono y WhatsApp de TODA la web con un único
// listener delegado: click_llamada (enlaces tel:) y click_whatsapp (wa.me / api.whatsapp.com).
// Así no hay que tocar cada botón y cualquier botón nuevo queda medido solo.
if (typeof window !== "undefined" && typeof document !== "undefined" && !window.__faroContactTracking) {
  window.__faroContactTracking = true;
  document.addEventListener(
    "click",
    (e) => {
      const a = e.target && e.target.closest ? e.target.closest("a[href]") : null;
      if (!a) return;
      const href = a.getAttribute("href") || "";
      let type = null;
      if (href.startsWith("tel:")) type = "click_llamada";
      else if (/^https?:\/\/(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)\//i.test(href)) type = "click_whatsapp";
      if (!type) return;
      trackClick(type, { extra: { href: href.split("?")[0].slice(0, 80) } });
    },
    true
  );
}
